import React, { useRef, useState } from "react";
import { Popover, PopoverHeader } from "reactstrap";
import { DotFillIcon, AlertIcon } from "@primer/octicons-react";

import useApi from "~/hooks/use-api";

type Warnings = Record<
  string,
  Array<{ id: string; title: string; description: string }>
>;

export default function WarningPopover(props: { org: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { data: warnings } = useApi<Warnings>(`/api/warnings`);

  const toggle = () => setPopoverOpen((v) => !v);

  const orgWarnings = warnings && warnings[props.org];

  if (!orgWarnings) return null;

  return (
    <div>
      <div
        role="button"
        ref={ref}
        className="d-inline-block text-warning"
        onClick={toggle}
      >
        <AlertIcon />
      </div>

      {ref.current && (
        <Popover
          trigger="legacy"
          toggle={toggle}
          target={ref.current}
          isOpen={popoverOpen}
          placement="bottom-end"
        >
          <PopoverHeader>
            {orgWarnings.length} warning{orgWarnings.length === 1 ? "" : "s"}
          </PopoverHeader>

          {orgWarnings.map((w) => (
            <div
              key={w.id}
              style={{ padding: "0.5rem 0.75rem" }}
              className="d-flex border-top border-light"
            >
              <div style={{ paddingRight: "0.75rem" }}>
                <DotFillIcon className="text-warning" />
              </div>
              <div style={{ paddingRight: "0.5rem" }}>
                <strong className="text-warning">{w.title}</strong>
                <br />
                {w.description}
              </div>
            </div>
          ))}
        </Popover>
      )}
    </div>
  );
}
